import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import * as types from './types';
import _fetchProducts from '../../../services/layer';
import { FAST_TIMER } from '~/const/timers';

function timer() {
  return _timer.apply(this, arguments);
}

function _timer() {
  _timer = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5() {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", new Promise(function (resolve) {
              setTimeout(function () {
                resolve();
              }, FAST_TIMER);
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _timer.apply(this, arguments);
}

export default {
  fetchProducts: function () {
    var _fetchProducts2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(store, payload) {
      var currentState, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.commit(types.SET_LOADING_LAYER, true);
              currentState = store.state;

              if (!payload.security) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return timer();

            case 5:
              if (!(payload.payload !== currentState.latest)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              _context.next = 9;
              return _fetchProducts(this, payload.payload);

            case 9:
              data = _context.sent;

              if (!(payload.payload !== currentState.latest)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return");

            case 12:
              store.commit(types.SET_LAYER_PRODUCTS, data);
              data = null;
              store.commit(types.SET_LOADING_LAYER, false);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchProducts(_x, _x2) {
      return _fetchProducts2.apply(this, arguments);
    }

    return fetchProducts;
  }(),
  resetProducts: function () {
    var _resetProducts = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref) {
      var commit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref.commit;
              commit(types.RESET_LAYER_PRODUCTS, []);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function resetProducts(_x3) {
      return _resetProducts.apply(this, arguments);
    }

    return resetProducts;
  }(),
  setCurrentLayer: function () {
    var _setCurrentLayer = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(store, payload) {
      var data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = payload;
              store.commit(types.SET_CURRENT_LAYER, data);
              data = null;

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function setCurrentLayer(_x4, _x5) {
      return _setCurrentLayer.apply(this, arguments);
    }

    return setCurrentLayer;
  }(),
  appendItems: function () {
    var _appendItems = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(store, payload) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              store.commit(types.APPEND_ITEMS, payload);

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function appendItems(_x6, _x7) {
      return _appendItems.apply(this, arguments);
    }

    return appendItems;
  }()
};